import * as React from "react";
import { ScrollList, ScrollListItem, Switch } from "@lib/components";
import { FastField } from "formik";

export type FormToggleRowOption = {
	name: string;
	label: string;
};

type Props = {
	variant: "v1" | "v2";
	options: FormToggleRowOption[];
	setFieldValue: (field: string, value: any) => void;
};

/**
 * Shared toggle list rows used by Staff forms (Restaurant Management, etc.)
 * and other dashboard forms that should match the same UI.
 */
export function FormToggleRowList(props: Props) {
	const { variant, options, setFieldValue } = props;

	if (variant === "v2") {
		return (
			<ScrollList height={null} version="v2">
				{options.map(({ name, label }) => (
					<FastField
						key={name}
						name={name}
						render={({ field }: any) => (
							<ScrollListItem
								className="flex-line centered"
								onClick={() => setFieldValue(name, !field.value)}
								style={{ justifyContent: "space-between", border: "none", padding: "15px 0" }}>
								<p
									className=""
									style={{ color: "#4B4F5E", fontFamily: "Inter", fontWeight: 500, fontSize: "14px" }}>
									{label}
								</p>
								<Switch
									id={name}
									checked={field.value || false}
									wrapperProps={{ style: { transform: "scale(0.8)" } }}
									onChange={(e) => setFieldValue(name, e.target.checked)}
								/>
							</ScrollListItem>
						)}
					/>
				))}
			</ScrollList>
		);
	}

	return (
		<ScrollList height={null}>
			{options.map(({ name, label }) => (
				<FastField
					key={name}
					name={name}
					render={({ field }: any) => (
						<ScrollListItem
							className="flex-line centered"
							onClick={() => setFieldValue(name, !field.value)}>
							<Switch
								id={name}
								checked={field.value || false}
								wrapperProps={{ style: { transform: "scale(0.8)" } }}
								onChange={(e) => setFieldValue(name, e.target.checked)}
							/>
							<p className="m-l-3">{label}</p>
						</ScrollListItem>
					)}
				/>
			))}
		</ScrollList>
	);
}
